import React from "react";
import { Tooltip } from "@flixbus/honeycomb-react";
import { Icon, IconAttentionSolid } from "@flixbus/honeycomb-icons-react";
import type { ResultCellContentProps } from "./ResultCellContent.types";
import { notComputableCell } from "../../../calculationMessages.constants";
import { formatNumber } from "@/utils/formatNumber";
import styles from "./ResultCellContent.module.scss";

const ResultCellContent: React.FC<ResultCellContentProps> = ({
  cell,
  tooltipId,
  tooltipPosition = "top",
}) => {
  if (cell.status === "NOT_COMPUTABLE") {
    return (
      <Tooltip
        id={tooltipId}
        content={notComputableCell}
        position={tooltipPosition}
        openOnHover
      >
        <span className={styles.notComputable}>
          N/A
          <Icon
            InlineIcon={IconAttentionSolid}
            extraClasses={styles.warningIcon}
          />
        </span>
      </Tooltip>
    );
  }
  return (
    <span className={styles.value}>
      {formatNumber(cell.value, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}
    </span>
  );
};

export default ResultCellContent;
